<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectGroup, type SelectGroupProps, useForwardProps } from "reka-ui";

const props = withDefaults(defineProps<SelectGroupProps>(), {});
// Only the set props; typed as such (see HPixSelectArrow).
const forwarded = useForwardProps(props) as ComputedRef<SelectGroupProps>;
</script>

<template>
  <SelectGroup v-bind="forwarded">
    <slot />
  </SelectGroup>
</template>
